import { orchestrator } from 'satcheljs';
import { onModuleClick } from 'owa-left-rail-utils';
import {
    LivePersonaCardInitializationState,
    LivePersonaEditorInitializationState,
} from '../store/schema/PersonaControlStore';
import {
    handleLpcInitializationStatus,
    handleLpeInitializationStatus,
} from '../actions/initializeLivePersonaCard';
import reInitLpc from '../actions/reInitLpc';
import { Module } from 'owa-workloads/lib/store/schema/Module';

export default () =>
    orchestrator(onModuleClick, async actionMessage => {
        // delete LPC
        handleLpcInitializationStatus(LivePersonaCardInitializationState.NotInitialized);
        handleLpeInitializationStatus(LivePersonaEditorInitializationState.NotInitialized);
        // cleanup previously loaded LPC/LPE
        (
            await import(/*webpackChunkName: "owaPeopleLoki"*/ 'owa-people-loki')
        ).freeBootstrapperMemory();

        if (actionMessage.module === Module.People) {
            reInitLpc(actionMessage.module, actionMessage.currentlySelectedModule);
        }
    });
